<template>
    <div class="vld-parent" v-if="View_acce">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>

        <div class="maintenance-tab">
            <CContainer fluid>
                <div class="row align-items-center">
                    <div class="col-12 col-lg-auto">
                        <div class="dbm_all_left">
                            <router-link :to="{ path:'/DASH/AA' }" class=" d-flex justify-content-center align-items-center">
                                {{this.getLanguage['DB']['DBMA']}}
                                <span class="annc_count ml-2">{{arry_san_length}}</span>
                                <i class="fa fa-arrow-right ml-2" aria-hidden="true"></i>
                            </router-link>
                        </div>
                    </div>
                    <div class="col">
                        <div class="dbm_all">
                            <span class="pl-0">{{this.getLanguage['DB']['MT']}}: </span>
                            <span class="dbm_title">{{ DB_Month }}</span>

                            <span>{{this.getLanguage['DB']['DG']}}: </span>
                            <span class="dbm_title">{{ DB_CDay }}</span>

                            <span>{{this.getLanguage['DB']['TD']}}: </span>
                            <span class="dbm_title">{{ DB_TDay }}</span>

                            <span>{{this.getLanguage['DB']['TE']}}: </span>
                            <span class="dbm_title">{{ DB_DProgress }} %</span>

                            <span>{{this.getLanguage['DB']['DRA']}}</span>
                            <span class="dbm_title">{{ DB_DRefresh }} {{this.dataFromCache ? '(c)' : ''}}</span>
                        </div>
                    </div>
                </div>
            </CContainer>
        </div>

        <!-- <div id="dashboardTab" class="w-100 mt-2">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <router-link :to="{ path:'/DASH/DBM'}" class="nav-link" :class="$route.path == '/DASH/DBM' ? 'active' : ''">
                    {{this.getLanguage['DB']['MONIT']}}
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ path:'/DASH/DBO'}" class="nav-link" :class="$route.path == '/DASH/DBO' ? 'active' : ''">
                    {{this.getLanguage['DB']['OPERAT']}}
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ path:'/DASH/DBP'}" class="nav-link" :class="$route.path == '/DASH/DBP' ? 'active' : ''">
                    {{this.getLanguage['DB']['PERF']}}
                </router-link>
            </li>
        </ul>
    </div> -->

        <div class="ds-wrapper">
            <div class="container-fluid">
                <CRow class="searchBar mb-1">
                    <div class='col-6 col-md-3 mb-2 mb-md-0' v-if="getUserInfo.AT !== 4">
                        <customtreeselect :multiple="false"
                                          :options="dd_agentgroup"
                                          :defaultExpandLevel="Infinity"
                                          :flat="true"
                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                          class="searchdashboard"
                                          @input="AgentGroupChangefs"
                                          v-model="searchAgent" />
                    </div>
                    <div class='col-6 col-md-3 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :async="true"
                                    :key="rtSubBrand"
                                    :load-options="loadSubBrandOptions"
                                    :cacheOptions="false"
                                    :defaultOptions="ddDefaultSubBrand"
                                    :options="dd_subagentgroup"
                                    :disable-branch-nodes="true"
                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                    :noResultsText="this.getLanguage['GL']['NRF']"
                                    :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                    v-model="searchSubAgent"
                                    openDirection="below"
                                    class="searchdashboard" />
                    </div>
                    <div class='col-6 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :options="dd_currency"
                                    :placeholder="this.utilGetDDLanguage('MTA.C')"
                                    class="searchdashboard"
                                    v-model="searchCurrency" />
                    </div>
                    <div class='col-6 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :options="dd_currency1"
                                    :placeholder="this.utilGetDDLanguage('MEM.CTCI')"
                                    class="searchdashboard"
                                    v-model="convertCurrency" />
                    </div>
                    <div class='col-12 col-md-2'>
                        <button type="button" class="btn searchBtn btn-success btn-sm btn-block" style="background: #6f6bd6;border: #6f6bd6" @click="nextGetUpdate(true, true, true)"><span class="searchIcon cil-search"></span><span>{{this.getLanguage['BTN']['SR']}}</span></button>
                    </div>
                </CRow>

                <div class="row">
                    <div class="col-12 col-xl-6">
                        <div class="row">
                            <div class="col-md-6 col-xl-6 pr-xl-0 mb-2">
                                <div class="card theme-box-container registered-member" @click="DailyRPage()">
                                    <div class="card-body dashHover row p-0 m-0">
                                        <div class="col-md-10 p-3 d-flex justify-content-start align-items-center">
                                            <div class="">
                                                <h2 class="theme-value">{{formatNumber(this.D_Register,0)}}</h2>
                                                <h6 class="theme-title">{{this.getLanguage["DB"]["DR"]}} <i aria-hidden="true" class="fa fa-arrow-right mx-1"></i></h6>
                                            </div>
                                        </div>
                                        <div class="col-auto p-3 registered-member-icon">
                                            <img width="40" src="../../src/assets/icons/icon-reg-user.svg" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 col-xl-6 pr-xl-0 mb-2">
                                <div class="card theme-box-container deposit-member" @click="DailyDPage()">
                                    <div class="custom_tooltip theme-red" >
                                        <div class="card-body dashHover row p-0 m-0">
                                            <div class="col-md-10 p-3 d-flex justify-content-start align-items-center">
                                                <div class="">
                                                    <h2 class="theme-value">{{formatNumber(this.D_DailyFirstDeposit,0)}} / {{formatNumber(this.D_ActiveMember,0)}}</h2>
                                                    <h6 class="theme-title">{{this.getLanguage["DB"]["AM"]}} <i aria-hidden="true" class="fa fa-arrow-right mx-1"></i></h6>
                                                </div>
                                            </div>
                                            <div class="col-auto p-3 deposit-member-icon">
                                                <img width="40" src="../../src/assets/icons/icon-deposit-member.svg" />
                                            </div>
                                        </div>
                                        <span class="tooltiptext tooltip-top">{{formatNumber(this.D_DailyFirstDeposit,0)}} {{this.getLanguage["DB"]["NDM"]}} / {{formatNumber(this.D_ActiveMember,0)}} {{this.getLanguage["DB"]["MD"]}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 col-xl-6 pr-xl-0 mb-2">
                                <div class="card theme-box-container  member-online" @click="MemberOnline()">
                                    <div class="card-body dashHover row p-0 m-0">
                                        <div class="col-md-10 p-3 d-flex justify-content-start align-items-center">
                                            <div class="">
                                                <h2 class="theme-value">{{formatNumber(this.setMemberOnline,0)}}</h2>
                                                <h6 class="theme-title">{{this.getLanguage["DB"]["MO"]}}<i aria-hidden="true" class="fa fa-arrow-right mx-1"></i></h6>
                                            </div>
                                        </div>
                                        <div class="col-auto p-3 member-online-icon">
                                            <img width="40" src="../../src/assets/icons/icon-member-online.svg" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 col-xl-6 pr-xl-0 mb-2">
                                <div class="card theme-box-container total-member" @click="AllMember()">
                                    <div class="card-body dashHover row p-0 m-0">
                                        <div class="col-md-10 p-3 d-flex justify-content-start align-items-center">
                                            <div class="">
                                                <h2 class="theme-value">{{formatNumber(this.setTotalMember,0)}}</h2>
                                                <h6 class="theme-title">{{this.getLanguage["DB"]["TM"]}}<i aria-hidden="true" class="fa fa-arrow-right mx-1"></i></h6>
                                            </div>
                                        </div>
                                        <div class="col-auto p-3 total-member-icon">
                                            <img width="40" src="../../src/assets/icons/icon-total-member.svg" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-xl-3 pr-xl-0 mb-2">
                        <div class="card theme-box-container theme-bg-pupple">
                            <div :class="['card-body','p-0', getUserInfo.AT==4?'':'dashHover']" @click="getUserInfo.AT==4?null:PNLPage()" style="display: flex; flex-direction: column; margin: 1rem 1rem 0 1rem; border-bottom: 1px solid #ffffff78; ">
                                <div class="row">
                                    <div class="col-10" @click.stop>
                                        <h6 class="font-weight-bold title-db">{{this.getLanguage['DB']['TPNL']}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency) }})</h6>
                                    </div>
                                    <div class="col-2"><i aria-hidden="true" class="fa fa-arrow-right"></i></div>
                                </div>
                                <div class="d-flex no-gutters justify-content-between align-items-center">
                                    <div class="text-break">
                                        <h2 class="font-weight-bold m-0" @click.stop v-if="this.AMT_D_PNL>=0">{{ formatNumber(this.AMT_D_PNL, 2,this.CurrencySymbol, false) }}</h2>
                                        <h2 class="font-weight-bold m-0" style="color: #e53636" @click.stop v-if="this.AMT_D_PNL<0">{{ formatNumber(this.AMT_D_PNL, 2,this.CurrencySymbol, false) }}</h2>
                                        <h6 class="theme-title prev-no">{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(this.AMT_Y_PNL, 2,this.CurrencySymbol, false) }}</h6>
                                    </div>
                                    <div class="text-right">
                                        <div class="font-weight-bold pr-2 mb-1" v-if="Compare_YD(this.AMT_D_PNL ,this.AMT_Y_PNL)>0">+{{formatNumber(Compare_YD(this.AMT_D_PNL ,this.AMT_Y_PNL), 2,this.CurrencySymbol, false)}}</div>
                                        <div class="font-weight-bold pr-2 mb-1" v-if="Compare_YD(this.AMT_D_PNL ,this.AMT_Y_PNL)<0">{{formatNumber(Compare_YD(this.AMT_D_PNL ,this.AMT_Y_PNL), 2,this.CurrencySymbol, false)}}</div>
                                        <div class="font-weight-bold pr-2 mb-1" v-if="Compare_YD(this.AMT_D_PNL ,this.AMT_Y_PNL)==0">{{formatNumber(Compare_YD(this.AMT_D_PNL ,this.AMT_Y_PNL), 2,this.CurrencySymbol, false)}}</div>

                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_PNL,this.AMT_Y_PNL)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_PNL,this.AMT_Y_PNL)), 2)}}%</small>
                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_PNL,this.AMT_Y_PNL)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_PNL,this.AMT_Y_PNL)), 2)}} %</small>
                                        <small class="mark-down rounded-pill" v-if="countMoneyPercentage(this.AMT_D_PNL,this.AMT_Y_PNL)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_PNL,this.AMT_Y_PNL)), 2)}}%</small>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex no-gutters justify-content-between align-items-center">
                                    <div class="col-auto">
                                        <h6 class="m-0 mtd-no" @click.stop>{{this.getLanguage["DB"]["MTD"]}} : <span v-bind:style="[this.AMT_MTD_PNL < 0 ? '{color: #980000}' : ''] " class="font-weight-bold">{{ formatNumber(this.AMT_MTD_PNL, 2,this.CurrencySymbol, false) }}</span></h6>
                                    </div>
                                    <div class="col-auto">
                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_MTD_PNL,this.AMT_LMTD_PNL)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_PNL,this.AMT_LMTD_PNL)), 2)}}%</small>
                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_MTD_PNL,this.AMT_LMTD_PNL)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_PNL,this.AMT_LMTD_PNL)), 2)}} %</small>
                                        <small class="mark-down rounded-pill" v-if="countMoneyPercentage(this.AMT_MTD_PNL,this.AMT_LMTD_PNL)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_PNL,this.AMT_LMTD_PNL)), 2)}}%</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <div class="card theme-box-container theme-bg-pupple">
                            <div class="card-body dashHover p-0" @click="PNLPage()" style="display: flex; flex-direction: column; margin: 1rem 1rem 0 1rem; border-bottom: 1px solid #ffffff78;">
                                <div class="row">
                                    <div class="col-10" @click.stop>
                                        <h6 class="font-weight-bold title-db">{{this.getLanguage['DB']['TNPNL']}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency) }})</h6>
                                    </div>
                                    <div class="col-2"><i aria-hidden="true" class="fa fa-arrow-right"></i></div>
                                </div>
                                <div class="d-flex no-gutters justify-content-between align-items-center">
                                    <div class="text-break">
                                        <h2 class="font-weight-bold m-0" v-if="countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA)>=0" @click.stop>{{ formatNumber(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA), 2, this.CurrencySymbol, false) }}</h2>
                                        <h2 class="font-weight-bold m-0" style="color: #e53636 " v-if="countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA)<0" @click.stop>{{ formatNumber(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA), 2, this.CurrencySymbol, false) }}</h2>
                                        <h6 class="theme-title prev-no">{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus), 2, this.CurrencySymbol, false) }}</h6>
                                    </div>
                                    <div class="text-right">
                                        <div class="font-weight-bold pr-2 mb-1" v-if="Compare_YD(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA) ,countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))>0">+{{formatNumber(Compare_YD(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA) ,countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus)), 2, this.CurrencySymbol, false)}}</div>
                                        <div class="font-weight-bold pr-2 mb-1" v-if="Compare_YD(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))<0">{{formatNumber(Compare_YD(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus)), 2, this.CurrencySymbol, false)}}</div>
                                        <div class="font-weight-bold pr-2 mb-1" v-if="Compare_YD(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA) ,countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))==0">{{formatNumber(Compare_YD(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA) ,countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus)), 2, this.CurrencySymbol, false)}}</div>

                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))), 2)}}%</small>
                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))==0">{{formatNumber(Math.abs(countMoneyPercentage(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))), 2)}} %</small>
                                        <small class="mark-down rounded-pill" v-if="countMoneyPercentage(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(countTotalNPNL(this.AMT_D_PNL, this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA),countTotalNPNL(this.AMT_Y_PNL, this.AMT_Y_Bonus))), 2)}}%</small>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex no-gutters justify-content-between align-items-center">
                                    <div class="col-auto">
                                        <h6 class="m-0 mtd-no">{{this.getLanguage["DB"]["MTD"]}} : <span v-bind:style="[countTotalNPNL(this.AMT_MTD_PNL, this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA) < 0 ? '{color: #980000}' : ''] " class="font-weight-bold">{{ formatNumber(countTotalNPNL(this.AMT_MTD_PNL, this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA), 2, this.CurrencySymbol, false) }}</span></h6>
                                    </div>
                                    <div class="col-auto">
                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(countTotalNPNL(this.AMT_MTD_PNL,  this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA),countTotalNPNL(this.AMT_LMTD_PNL, this.AMT_LMTD_NPNL))>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(countTotalNPNL(this.AMT_MTD_PNL,  this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA),countTotalNPNL(this.AMT_LMTD_PNL, this.AMT_LMTD_NPNL))), 2)}}%</small>
                                        <small class="mark-up rounded-pill" v-if="countMoneyPercentage(countTotalNPNL(this.AMT_MTD_PNL,  this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA),countTotalNPNL(this.AMT_LMTD_PNL, this.AMT_LMTD_NPNL))==0">{{formatNumber(Math.abs(countMoneyPercentage(countTotalNPNL(this.AMT_MTD_PNL,  this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA),countTotalNPNL(this.AMT_LMTD_PNL, this.AMT_LMTD_NPNL))), 2)}} %</small>
                                        <small class="mark-down rounded-pill" v-if="countMoneyPercentage(countTotalNPNL(this.AMT_MTD_PNL,  this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA),countTotalNPNL(this.AMT_LMTD_PNL, this.AMT_LMTD_NPNL))<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(countTotalNPNL(this.AMT_MTD_PNL,  this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA),countTotalNPNL(this.AMT_LMTD_PNL, this.AMT_LMTD_NPNL))), 2)}}%</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'col-12 col-xl-6 mb-2 pr-xl-0':'col-12 col-xl-12 mb-2'">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="font-weight-bold title-db mb-0" @click.stop>{{this.getLanguage['DB']['MOD']}}</h5>
                                    </div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'hidden':'col-6 col-md-1 my-1 d-none d-sm-block'"></div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'col-6 col-md-4 col-xl-4 my-1':'col-6 col-md-2 my-1'">
                                        <div class="row align-items-center member-online-details">
                                            <div class="col-5 col-xl-5">
                                                <div class="round-button-circle">
                                                    <div class="round-button">
                                                        <img src="../../src/assets/icons/icon-desktop.svg" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h2 class="theme-cicle-value font-weight-bold mb-0"><span>{{formatNumber(this.setMemberOnline_DESKTOP,0)}}</span></h2>
                                                <h6 class="theme-cicle-title mb-0"><span>{{this.getLanguage['DB']['DSK']}}</span></h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'col-6 col-md-4 col-xl-4 my-1':'col-6 col-md-2 my-1'">
                                        <div class="row align-items-center member-online-details">
                                            <div class="col-5 col-xl-5">
                                                <div class="round-button-circle">
                                                    <img src="../../src/assets/icons/icon-mobile.svg" />
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h2 class="theme-cicle-value font-weight-bold mb-0"><span>{{formatNumber(this.setMemberOnline_MOBILE,0)}}</span></h2>
                                                <h6 class="theme-cicle-title mb-0"><span>{{this.getLanguage['DB']['MB']}}</span></h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'col-6 col-md-4 col-xl-4 my-1':'col-6 col-md-2 my-1'">
                                        <div class="row align-items-center member-online-details">
                                            <div class="col-5 col-xl-5">
                                                <div class="round-button-circle">
                                                    <div class="round-button">
                                                        <img src="../../src/assets/icons/icon-android.svg" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h2 class="theme-cicle-value font-weight-bold mb-0"><span>{{formatNumber(this.setMemberOnline_ANDROID,0)}}</span></h2>
                                                <h6 class="theme-cicle-title mb-0"><span>{{this.getLanguage['DB']['AA']}}</span></h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'col-6 col-md-4 col-xl-4 my-1':'col-6 col-md-2 my-1'">
                                        <div class="row align-items-center member-online-details">
                                            <div class="col-5 col-xl-5">
                                                <div class="round-button-circle">
                                                    <div class="round-button">
                                                        <img src="../../src/assets/icons/icon-apple.svg" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h2 class="theme-cicle-value font-weight-bold mb-0"><span>{{formatNumber(this.setMemberOnline_IOS,0)}}</span></h2>
                                                <h6 class="theme-cicle-title mb-0"><span>{{this.getLanguage['DB']['IA']}}</span></h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'col-6 col-md-4 col-xl-4 my-1':'col-6 col-md-2 my-1'">
                                        <div class="row align-items-center member-online-details">
                                            <div class="col-5 col-xl-5">
                                                <div class="round-button-circle">
                                                    <div class="round-button">
                                                        <img src="../../src/assets/icons/icon-api.svg" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h2 class="theme-cicle-value font-weight-bold mb-0"><span>{{formatNumber(this.setMemberOnline_API,0)}}</span></h2>
                                                <h6 class="theme-cicle-title mb-0"><span>{{this.getLanguage['DB']['API']}}</span></h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0) ? 'hidden':'col-6 col-md-1 my-1 d-none d-sm-block'"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 mb-2" v-if="(getUserInfo.AT == 0 || getUserInfo.AT == 1 ||getUserInfo.AT == 2 || getUserInfo.AT == 3) && (top3b != null && top3b.length != 0)">
                        <div class="card theme-box-container h-100 topbottom5box">
                            <div class="card-body dashHover">
                                <div class="row h-100">
                                    <div class="col-md-6" style="border-right: 1px solid rgb(230 230 230) ">
                                        <div class="row">
                                            <div class="col-9 col-md-10">
                                                <h5 class="font-weight-bold title-db mb-0">{{this.getLanguage["DB"]["T5B"]}}</h5>
                                            </div>
                                            <div class="col-3 col-md-2 text-right" @click="Gotop3Brand(1, getUserInfo.AT)">
                                                <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                            </div>
                                        </div>

                                        <div class="position-relative w-100">
                                            <div class="brand-wrapper">
                                                <div class="brand-ranking pt-2" v-if="top3b != null && top3b.length != 0" v-for="(data,index) in top3b" @click="Gotop3Brand(1, getUserInfo.AT, data)">
                                                    <div class="d-flex">
                                                        <div style="width:70%;">
                                                            <h5 :class="data.TN >= 0? 'positive-number': 'negative-number'">
                                                                <i class="fa fa-caret-up"></i>
                                                                <span v-if="data.SAGI > 0">{{data.SAGN}} <span style="color:#000">({{ formatNumber(data.OC, 0) }})</span></span>
                                                                <span v-else>{{data.AGN}} <span style="color:#000">({{ formatNumber(data.OC, 0) }})</span></span>
                                                            </h5>
                                                        </div>
                                                        <div style="width:30%;" class="text-right">
                                                            <h6 :class="data.TN >= 0? 'positive-number': 'negative-number'">{{formatNumber(data.TN, 2, CurrencySymbol, false)}}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-center" v-if="top3b == null || top3b.length == 0">
                                                    <h2 class="font-weight-bold" style="font-size: 1.8em; font-weight: 600 !important; color: #dbdbdb;">{{this.getLanguage['GL']['NR']}}</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="subHeaderHR my-2 d-block d-md-none"></div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-9 col-md-10">
                                                <h5 class="font-weight-bold title-db mb-0">{{this.getLanguage["DB"]["B5B"]}}</h5>
                                            </div>
                                            <div class="col-3 col-md-2 text-right" style="color: #a3a3a3" @click="Gotop3Brand(0, getUserInfo.AT)">
                                                <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                            </div>
                                        </div>

                                        <div class="position-relative w-100">
                                            <div class="brand-wrapper">
                                                <div class="brand-ranking pt-2" v-if="bottom3b != null && bottom3b.length != 0" v-for="(data,index) in bottom3b" @click="Gotop3Brand(1, getUserInfo.AT, data)">
                                                    <div class="d-flex">
                                                        <div style="width:70%;">
                                                            <h5 :class="data.TN >= 0? 'positive-number': 'negative-number'">
                                                                <i class="fa fa-caret-down"></i>
                                                                <span v-if="data.SAGI > 0">{{data.SAGN}} <span style="color:#000">({{ formatNumber(data.OC, 0) }})</span></span>
                                                                <span v-else>{{data.AGN}} <span style="color:#000">({{ formatNumber(data.OC, 0) }})</span></span>
                                                            </h5>
                                                        </div>
                                                        <div style="width:30%;" class="text-right">
                                                            <h6 :class="data.TN >= 0? 'positive-number': 'negative-number'">{{formatNumber(data.TN, 2, CurrencySymbol, false)}}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-center" v-if="bottom3b == null || bottom3b.length == 0">
                                                    <h2 class="font-weight-bold" style="font-size: 1.8em; font-weight: 600 !important; color: #dbdbdb;">{{this.getLanguage['GL']['NR']}}</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-6">
                        <div class="row">
                            <div class="col-md pr-xl-0">
                                <div class="card theme-box-container mb-2" style="border-top: solid 5px #6d6ba3">
                                    <div>
                                        <div class="card-body dashHover" :style="array_dailyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'" @click="MonthlyRegisterSourcePage(null,'h')">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage["DB"]["DDR"]}}</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>
                                            <h6 v-if="array_dailyRS.length==0">{{this.getLanguage['GL']['NR']}}</h6>

                                            <div v-for="(data,index) in array_dailyRS" v-if="index < 3">
                                                <div class="d-flex no-gutters justify-content-between align-items-center" :class="index == 2 || index == array_monthlyRS.length - 1 ?'' : 'border-bottom2'" @click="MonthlyRegisterSourcePage(data.RSN,'h')">
                                                    <h6 v-if="data.RSN=='DIRECT'" class="my-1" @click.stop>{{getLanguage['DB'][data.RSN]}}</h6>
                                                    <h6 v-else class="my-1" @click.stop>{{data.RSN}}</h6>
                                                    <span class="font-weight-bold" @click.stop>{{formatNumber(data.RC,0)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.75rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="col-auto" style="visibility: hidden;">
                                                    -
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="card-body dashHover" :style="array_monthlyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'" @click="MonthlyRegisterSourcePage(null,'d')">

                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage["DB"]["MTDR"]}}</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>
                                            <h6 v-if="array_monthlyRS.length==0">{{this.getLanguage['GL']['NR']}}</h6>

                                            <div v-for="(data,index) in array_monthlyRS" v-if="index < 3">
                                                <div class="d-flex no-gutters justify-content-between align-items-center" :class="index == 2 || index == array_monthlyRS.length - 1 ?'' : 'border-bottom2'" @click="MonthlyRegisterSourcePage(data.RSN,'d')">
                                                    <h6 v-if="data.RSN=='DIRECT'" class="my-1" @click.stop>{{getLanguage['DB'][data.RSN]}}</h6>
                                                    <h6 v-else class="my-1" @click.stop>{{data.RSN}}</h6>
                                                    <span class="font-weight-bold" @click.stop>{{formatNumber(data.RC,0)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.75rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center" @click="MonthlyRPage()">
                                                <div class="col-auto">
                                                    <h6 class="m-0 font-weight-bold" @click.stop>{{this.getLanguage["DB"]["MTD"]}} : <span class="font-weight-bold">{{ formatNumber(this.MTD_Register, 0) }}</span></h6>
                                                </div>
                                                <div class="col-auto">
                                                    <small class="font-weight-bold text-green" v-if="countPercentage(this.MTD_Register,this.L_MTD_Register)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.MTD_Register,this.L_MTD_Register)), 2)}}%</small>
                                                    <small class="font-weight-bold text-green" v-if="countPercentage(this.MTD_Register,this.L_MTD_Register)==0">{{formatNumber(Math.abs(countPercentage(this.MTD_Register,this.L_MTD_Register)), 2)}} %</small>
                                                    <small class="font-weight-bold text-red1" v-if="countPercentage(this.MTD_Register,this.L_MTD_Register)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.MTD_Register,this.L_MTD_Register)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md pr-xl-0">
                                <div class="card theme-box-container mb-2" @click="DailyDPage()" style="border-top: solid 5px #30878e">
                                    <div>
                                        <div class="card-body dashHover" :style="array_dailyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage['DB']['DDPT']}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency)}})</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>

                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="text-break">
                                                    <h2 :class="this.AMT_D_Deposit > 0? 'text-green1': ''" class="font-weight-bold m-0" @click.stop>{{ formatNumber(this.AMT_D_Deposit, 2,this.CurrencySymbol, false) }}</h2>
                                                    <span>{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(this.AMT_Y_Deposit, 2,this.CurrencySymbol, false) }}</span>
                                                </div>

                                                <div class="text-right">
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Deposit ,this.AMT_Y_Deposit)>0">+{{formatNumber(Compare_YD(this.AMT_D_Deposit ,this.AMT_Y_Deposit), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Deposit ,this.AMT_Y_Deposit)<0">{{formatNumber(Compare_YD(this.AMT_D_Deposit ,this.AMT_Y_Deposit), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Deposit ,this.AMT_Y_Deposit)==0">{{formatNumber(Compare_YD(this.AMT_D_Deposit ,this.AMT_Y_Deposit), 0)}}</div>

                                                    <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Deposit,this.AMT_Y_Deposit)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Deposit,this.AMT_Y_Deposit)), 2)}}%</small>
                                                    <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Deposit,this.AMT_Y_Deposit)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Deposit,this.AMT_Y_Deposit)), 2)}} %</small>
                                                    <small class="mark-down rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Deposit,this.AMT_Y_Deposit)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Deposit,this.AMT_Y_Deposit)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.75rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="col-auto">
                                                    <h6 class="m-0 font-weight-bold" @click.stop>
                                                        {{this.getLanguage["DB"]["MTD"]}} :
                                                        <span :class="this.AMT_D_Deposit > 0? 'text-green1': ''" class="font-weight-bold">{{ formatNumber(this.AMT_MTD_Deposit, 2,this.CurrencySymbol, false) }}</span>
                                                    </h6>
                                                </div>
                                                <div class="col-auto">
                                                    <small class="font-weight-bold text-green" v-if="countMoneyPercentage(this.AMT_MTD_Deposit,this.AMT_LMTD_Deposit)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_Deposit,this.AMT_LMTD_Deposit)), 2)}}%</small>
                                                    <small class="font-weight-bold text-green" v-if="countMoneyPercentage(this.AMT_MTD_Deposit,this.AMT_LMTD_Deposit)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_Deposit,this.AMT_LMTD_Deposit)), 2)}} %</small>
                                                    <small class="font-weight-bold text-red1" v-if="countMoneyPercentage(this.AMT_MTD_Deposit,this.AMT_LMTD_Deposit)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_Deposit,this.AMT_LMTD_Deposit)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="card-body dashHover" :style="array_monthlyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage['DB']['NOD']}}</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>

                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div>
                                                    <h2 class="font-weight-bold m-0" @click.stop>{{ formatNumber(this.D_Deposit, 0) }}</h2>
                                                    <span>{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(this.Y_Deposit, 0) }}</span>
                                                </div>
                                                <div class="text-right">
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.D_Deposit ,this.Y_Deposit)>0">+{{formatNumber(Compare_YD(this.D_Deposit ,this.Y_Deposit), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.D_Deposit ,this.Y_Deposit)<0">{{formatNumber(Compare_YD(this.D_Deposit ,this.Y_Deposit), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.D_Deposit ,this.Y_Deposit)==0">{{formatNumber(Compare_YD(this.D_Deposit ,this.Y_Deposit), 0)}}</div>

                                                    <small class="mark-up rounded-pill" v-if="countPercentage(this.D_Deposit,this.Y_Deposit)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.D_Deposit,this.Y_Deposit)), 2)}}%</small>
                                                    <small class="mark-up rounded-pill" v-if="countPercentage(this.D_Deposit,this.Y_Deposit)==0">{{formatNumber(Math.abs(countPercentage(this.D_Deposit,this.Y_Deposit)), 2)}} %</small>
                                                    <small class="mark-down rounded-pill" v-if="countPercentage(this.D_Deposit,this.Y_Deposit)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.D_Deposit,this.Y_Deposit)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.75rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="col-auto">
                                                    <h6 class="m-0 font-weight-bold" @click.stop>{{this.getLanguage["DB"]["MTD"]}} : <span class="font-weight-bold">{{ formatNumber(this.MTD_Deposit, 0) }}</span></h6>
                                                </div>
                                                <div class="col-auto">
                                                    <small class="font-weight-bold text-green" v-if="countPercentage(this.MTD_Deposit,this.L_MTD_Deposit)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.MTD_Deposit,this.L_MTD_Deposit)), 2)}}%</small>
                                                    <small class="font-weight-bold text-green" v-if="countPercentage(this.MTD_Deposit,this.L_MTD_Deposit)==0">{{formatNumber(Math.abs(countPercentage(this.MTD_Deposit,this.L_MTD_Deposit)), 2)}} %</small>
                                                    <small class="font-weight-bold text-red1" v-if="countPercentage(this.MTD_Deposit,this.L_MTD_Deposit)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.MTD_Deposit,this.L_MTD_Deposit)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="row">
                            <div class="col-md pr-xl-0">
                                <div class="card theme-box-container mb-2" @click="DailyWPage()" style="border-top: solid 5px #e53636">
                                    <div>
                                        <div class="card-body dashHover" :style="array_dailyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage['DB']['DW']}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency) }})</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>

                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="text-break">
                                                    <h2 :class="this.AMT_D_Withdraw > 0? 'text-red1': ''" class="font-weight-bold m-0" @click.stop>{{ formatNumber(this.AMT_D_Withdraw*-1, 2,this.CurrencySymbol, false) }}</h2>
                                                    <span>{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(this.AMT_Y_Withdraw, 2,this.CurrencySymbol, false) }}</span>
                                                </div>
                                                <div class="text-right">
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Withdraw ,this.AMT_Y_Withdraw)>0">+{{formatNumber(Compare_YD(this.AMT_D_Withdraw ,this.AMT_Y_Withdraw), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Withdraw ,this.AMT_Y_Withdraw)<0">{{formatNumber(Compare_YD(this.AMT_D_Withdraw ,this.AMT_Y_Withdraw), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Withdraw ,this.AMT_Y_Withdraw)==0">{{formatNumber(Compare_YD(this.AMT_D_Withdraw ,this.AMT_Y_Withdraw), 0)}}</div>

                                                    <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Withdraw,this.AMT_Y_Withdraw)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Withdraw,this.AMT_Y_Withdraw)), 2)}}%</small>
                                                    <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Withdraw,this.AMT_Y_Withdraw)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Withdraw,this.AMT_Y_Withdraw)), 2)}} %</small>
                                                    <small class="mark-down rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Withdraw,this.AMT_Y_Withdraw)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Withdraw,this.AMT_Y_Withdraw)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.75rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="col-auto">
                                                    <h6 class="m-0 font-weight-bold" @click.stop>
                                                        {{this.getLanguage["DB"]["MTD"]}} :
                                                        <span :class="this.AMT_MTD_Withdraw > 0? 'text-red1': ''" class="font-weight-bold">{{ formatNumber(this.AMT_MTD_Withdraw*-1, 2,this.CurrencySymbol, false) }}</span>
                                                    </h6>
                                                </div>
                                                <div class="col-auto">
                                                    <small class="font-weight-bold text-green" v-if="countMoneyPercentage(this.AMT_MTD_Withdraw,this.AMT_LMTD_Withdraw)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_Withdraw,this.AMT_LMTD_Withdraw)), 2)}}%</small>
                                                    <small class="font-weight-bold text-green" v-if="countMoneyPercentage(this.AMT_MTD_Withdraw,this.AMT_LMTD_Withdraw)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_Withdraw,this.AMT_LMTD_Withdraw)), 2)}} %</small>
                                                    <small class="font-weight-bold text-red1" v-if="countMoneyPercentage(this.AMT_MTD_Withdraw,this.AMT_LMTD_Withdraw)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_MTD_Withdraw,this.AMT_LMTD_Withdraw)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="card-body dashHover" :style="array_monthlyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage['DB']['NOW']}}</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>

                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div>
                                                    <h2 class="font-weight-bold m-0" @click.stop>{{ formatNumber(this.D_Withdraw, 0) }}</h2>
                                                    <span>{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(this.Y_Withdraw, 0) }}</span>
                                                </div>
                                                <div class="text-right">
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.D_Withdraw ,this.Y_Withdraw)>0">+{{formatNumber(Compare_YD(this.D_Withdraw ,this.Y_Withdraw), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.D_Withdraw ,this.Y_Withdraw)<0">{{formatNumber(Compare_YD(this.D_Withdraw ,this.Y_Withdraw), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.D_Withdraw ,this.Y_Withdraw)==0">{{formatNumber(Compare_YD(this.D_Withdraw ,this.Y_Withdraw), 0)}}</div>

                                                    <small class="mark-up rounded-pill" v-if="countPercentage(this.D_Withdraw,this.Y_Withdraw)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.D_Withdraw,this.Y_Withdraw)), 2)}}%</small>
                                                    <small class="mark-up rounded-pill" v-if="countPercentage(this.D_Withdraw,this.Y_Withdraw)==0">{{formatNumber(Math.abs(countPercentage(this.D_Withdraw,this.Y_Withdraw)), 2)}} %</small>
                                                    <small class="mark-down rounded-pill" v-if="countPercentage(this.D_Withdraw,this.Y_Withdraw)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.D_Withdraw,this.Y_Withdraw)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.75rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="col-auto">
                                                    <h6 class="m-0 font-weight-bold" @click.stop>{{this.getLanguage["DB"]["MTD"]}} : <span class="font-weight-bold">{{ formatNumber(this.MTD_Withdraw, 0) }}</span></h6>
                                                </div>
                                                <div class="col-auto">
                                                    <small class="font-weight-bold text-green" v-if="countPercentage(this.MTD_Withdraw,this.L_MTD_Withdraw)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.MTD_Withdraw,this.L_MTD_Withdraw)), 2)}}%</small>
                                                    <small class="font-weight-bold text-green" v-if="countPercentage(this.MTD_Withdraw,this.L_MTD_Withdraw)==0">{{formatNumber(Math.abs(countPercentage(this.MTD_Withdraw,this.L_MTD_Withdraw)), 2)}} %</small>
                                                    <small class="font-weight-bold text-red1" v-if="countPercentage(this.MTD_Withdraw,this.L_MTD_Withdraw)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countPercentage(this.MTD_Withdraw,this.L_MTD_Withdraw)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card theme-box-container mb-2" style="border-top: solid 5px #6f6bd6">
                                    <div>
                                        <div class="card-body dashHover" @click="DailyExpenseBreakdown()" :style="array_dailyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage["DB"]["DBC"]}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency) }})</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>

                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="text-break">
                                                    <h2 :class="this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA > 0? 'text-red1': ''" class="font-weight-bold m-0" @click.stop>{{ formatNumber((this.AMT_D_Bonus+this.AMT_D_DLS+this.AMT_D_AR+this.AMT_D_Aff+this.AMT_D_TNMT+this.AMT_D_MSA)*-1, 2,this.CurrencySymbol, false) }}</h2>
                                                    <span>{{this.getLanguage["DB"]["PREV"]}}. {{ formatNumber(this.AMT_Y_Bonus*-1, 2,this.CurrencySymbol, false) }}</span>
                                                </div>
                                                <div class="text-right">
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Bonus ,this.AMT_Y_Bonus)>0">+{{formatNumber(Compare_YD(this.AMT_D_Bonus ,this.AMT_Y_Bonus), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Bonus ,this.AMT_Y_Bonus)<0">{{formatNumber(Compare_YD(this.AMT_D_Bonus ,this.AMT_Y_Bonus), 0)}}</div>
                                                    <div class="font-weight-bold pr-3 mb-1" v-if="Compare_YD(this.AMT_D_Bonus ,this.AMT_Y_Bonus)==0">{{formatNumber(Compare_YD(this.AMT_D_Bonus ,this.AMT_Y_Bonus), 0)}}</div>

                                                    <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Bonus,this.AMT_Y_Bonus)>0">&#9650;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Bonus,this.AMT_Y_Bonus)), 2)}}%</small>
                                                    <small class="mark-up rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Bonus,this.AMT_Y_Bonus)==0">{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Bonus,this.AMT_Y_Bonus)), 2)}} %</small>
                                                    <small class="mark-down rounded-pill" v-if="countMoneyPercentage(this.AMT_D_Bonus,this.AMT_Y_Bonus)<0">&#9660;&nbsp;&nbsp;{{formatNumber(Math.abs(countMoneyPercentage(this.AMT_D_Bonus,this.AMT_Y_Bonus)), 2)}}%</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.2rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center row">
                                                <div class="col-4 dashHover" @click="DailyExpenseBreakdown('BNS')">
                                                    <small>{{this.getLanguage["DB"]["BNS"]}}: </small>
                                                    <small :class="this.AMT_D_Bonus > 0? 'text-red1': ''" class="font-weight-bold m-0">{{ formatShortenNumberWithoutSymbol(this.AMT_D_Bonus*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="DailyExpenseBreakdown('DLS')">
                                                    <small>{{this.getLanguage["DB"]["DLS"]}}: </small>
                                                    <small :class="this.AMT_D_DLS > 0? 'text-red1': ''" class="font-weight-bold m-0">{{ formatShortenNumberWithoutSymbol(this.AMT_D_DLS*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="DailyExpenseBreakdown('AR')">
                                                    <small>{{this.getLanguage["DB"]["AR"]}}: </small>
                                                    <small :class="this.AMT_D_AR > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_D_AR*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="DailyExpenseBreakdown('AFF')">
                                                    <small>{{this.getLanguage["DB"]["AFF"]}}: </small>
                                                    <small :class="this.AMT_D_Aff > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_D_Aff*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="DailyExpenseBreakdown('TNMT')">
                                                    <small>{{this.getLanguage["DB"]["TNMT"]}}: </small>
                                                    <small :class="this.AMT_D_TNMT > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_D_TNMT*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="DailyExpenseBreakdown('MSA')">
                                                    <small>{{this.getLanguage["DB"]["MSA"]}}: </small>
                                                    <small :class="this.AMT_D_MSA > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_D_MSA*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <!--<div class="col-4 dashHover" @click="DailyExpenseBreakdown">
                                                <small>{{this.getLanguage["BETRPT"]["SPRWL"]}}: </small>
                                                <small :class="this.AMT_D_SPR > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_D_SPR*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                            </div>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="card-body dashHover" @click="MonthlyExpenseBreakdown()" :style="array_monthlyRS.length >= 3 ? 'height: 160px;' : 'height: 140px;'">
                                            <div class="row">
                                                <div class="col-10">
                                                    <h6 class="font-weight-bold title-db" @click.stop>{{this.getLanguage["DB"]["MBC"]}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency) }})</h6>
                                                </div>
                                                <div class="col-2">
                                                    <i aria-hidden="true" class="fa fa-arrow-right text-grey"></i>
                                                </div>
                                            </div>

                                            <div class="d-flex no-gutters justify-content-between align-items-center">
                                                <div class="text-break">
                                                    <h2 :class="this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA > 0? 'text-red1': ''" class="font-weight-bold m-0" @click.stop>{{ formatNumber((this.AMT_MTD_Bonus+this.AMT_MTD_DLS+this.AMT_MTD_AR+this.AMT_MTD_AFF+this.AMT_MTD_TNMT+this.AMT_MTD_MSA)*-1, 2,this.CurrencySymbol, false) }}</h2>
                                                    <span>{{this.getLanguage["DB"]["CAP"]}}. {{ formatNumber(this.AMT_MTD_BonusC, 2) }}</span>
                                                </div>
                                                <div class="text-right">
                                                    <span></span>
                                                    <br />
                                                    <small class="mark-up rounded-pill">{{formatNumber(Math.abs(CalculateBCPercentage(this.AMT_MTD_Bonus,this.AMT_MTD_BonusC)), 2)}} %</small><br />
                                                    <small class="invisible font-weight-bold text-green">{{formatNumber(this.AMT_D_Bonus - this.AMT_Y_Bonus, 2)}}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer" style="padding:0.2rem 1rem">
                                            <div class="d-flex no-gutters justify-content-between align-items-center row">
                                                <div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('BNS')">
                                                    <small>{{this.getLanguage["DB"]["BNS"]}}: </small>
                                                    <small :class="this.AMT_MTD_Bonus > 0? 'text-red1': ''" class="font-weight-bold m-0">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_Bonus*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('DLS')">
                                                    <small>{{this.getLanguage["DB"]["DLS"]}}: </small>
                                                    <small :class="this.AMT_MTD_DLS > 0? 'text-red1': ''" class="font-weight-bold m-0">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_DLS*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('AR')">
                                                    <small>{{this.getLanguage["DB"]["AR"]}}: </small>
                                                    <small :class="this.AMT_MTD_AR > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_AR*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('AFF')">
                                                    <small>{{this.getLanguage["DB"]["AFF"]}}: </small>
                                                    <small :class="this.AMT_MTD_AFF > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_AFF*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('TNMT')">
                                                    <small>{{this.getLanguage["DB"]["TNMT"]}}: </small>
                                                    <small :class="this.AMT_MTD_TNMT > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_TNMT*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('MSA')">
                                                    <small>{{this.getLanguage["DB"]["MSA"]}}: </small>
                                                    <small :class="this.AMT_MTD_MSA > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_MSA*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                                </div>
                                                <!--<div class="col-4 dashHover" @click="MonthlyExpenseBreakdown('SPR')">
                                                <small>{{this.getLanguage["BETRPT"]["SPRWL"]}}: </small>
                                                <small :class="this.AMT_MTD_SPR > 0? 'text-red1': ''" class="font-weight-bold m-0 ">{{ formatShortenNumberWithoutSymbol(this.AMT_MTD_SPR*-1, ".", ",", 2,this.CurrencySymbol) }}</small>
                                            </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="shortformBar">
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["MTD"]}} - {{this.getLanguage["DB"]["MTDE"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["PREV"]}}. - {{this.getLanguage["DB"]["PREVIOUS"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["BNS"]}}. - {{this.getLanguage["DB"]["BONUS"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["CAP"]}}. - {{this.getLanguage["DB"]["CAPPING"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["DLS"]}} - {{this.getLanguage["DB"]["DBDLS"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["AR"]}} - {{this.getLanguage["DB"]["DBAR"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["AFF"]}} - {{this.getLanguage["DB"]["DBAFF"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["TNMT"]}} - {{this.getLanguage["DB"]["DBTNMT"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["DB"]["MSA"]}} - {{this.getLanguage["DB"]["DBMSA"]}}</p>
                            <!--<p class="pr-3 mb-0"><span class="text-red1">* </span>{{this.getLanguage["BETRPT"]["SPRWL"]}} - {{this.getLanguage["DB"]["SPR"]}}</p>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<WidgetsDropdown />-->
        <div class="position-relative mt-3">
            <apexchart ref="apexchart" class="container-fluid" height="350" type="bar" :options="chartOptions" :series="series"></apexchart>
            <div class="text-white text-left day-list mb-3" style=" position: absolute; top: 2px; right: 70px;">
                <span :class="chartDDay ? 'durationActive pointer' : 'durationNoActive pointer'" @click="showChartType(1, true)">{{this.getLanguage["DB"]["BD"]}}</span>
                <span :class="!chartDDay ? 'durationActive pointer' : 'durationNoActive pointer'" @click="showChartType(0, true)">{{this.getLanguage["DB"]["BM"]}}</span>
            </div>
        </div>

        <!-- user activity table -->
        <div class="container-fluid" v-if="View_acce2">
            <div class='dashBoardPaddingTop'>
                <div class='table-wrapper' style="margin: 0;">
                    <header class="table-header p-0">
                        <button type="button" class="btn p-0" @click="MemberActivityPage()">
                            <div id="dashboardmonitoring"></div>
                            <strong><i class="fa-solid fa-shuffle"></i> {{this.getLanguage['DB']['RMAL']}}</strong>
                        </button>
                    </header>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../modules/GenericHelper.js";
    import moment from 'moment'
    import Loading from 'vue-loading-overlay';
    import { constRejectReasonP, constRejectReasonD, constRejectReasonW, constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import VueApexCharts from 'vue-apexcharts'
    import Vue from 'vue'
    import $ from 'jquery'

    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)

    export default {
        props: ['arry_san_length'],
        mixins: [genericHelper],
        computed: {
            ...mapGetters('UserInfo', ['getUserInfo']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'checkModuleIndex']),
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion'
            ]),
            ...mapGetters('SMBData', [
                'getCurrencyCode'
            ]),
        },
        name: 'DashboardMonitoring',
        components: {
            Loading,
            Treeselect,
            customtreeselect,
            DateRangePicker
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_isSort: false,
                bool_firstLogin: false,
                bool_firstsearchAgent: false,
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: [],//subagent default group option
                dd_currency: [],
                dd_currency1: [],
                obj_details: {},
                arry_details: [],
                SummaryArray: [],
                searchAgent: null,
                searchSubAgent: null,
                searchCurrency: null,
                convertCurrency: null,
                setMemberOnline: 0,
                setMemberOnline_DESKTOP: 0,
                setMemberOnline_MOBILE: 0,
                setMemberOnline_ANDROID: 0,
                setMemberOnline_IOS: 0,
                setMemberOnline_API: 0,
                setTotalMember: 0,
                array_monthlyRS: [],
                array_dailyRS: [],
                AutoGetUpdateTO: null,
                AutoUpdateTO: null,
                rtSubBrand: 0,//subagent dd refresh key

                MTD_Deposit: 0, // Month to Date
                L_MTD_Deposit: 0, // Month to Date
                MTD_Withdraw: 0,
                L_MTD_Withdraw: 0,
                MTD_Register: 0,
                L_MTD_Register: 0,
                AMT_MTD_Bonus: 0,
                AMT_MTD_DLS: 0,
                AMT_MTD_AR: 0,
                AMT_MTD_AFF: 0,
                AMT_MTD_TNMT: 0,
                AMT_MTD_MSA: 0,
                AMT_MTD_BonusC: 0,
                AMT_Y_Deposit: 0,
                AMT_Y_Withdraw: 0,

                D_Deposit: 0, // Day
                D_Withdraw: 0,
                D_Register: 0,
                D_DailyFirstDeposit: 0,
                D_ActiveMember: 0,

                CD_Deposit: [], // Chart
                CD_Register: [],
                CYTD_Register: [],
                CD_DepositMoney: [],
                getMemberDepositDataByMonthChartS: [],
                getMemberDepositDataByYearChartS: [],

                Y_Deposit: 0, // Yesterday
                Y_Withdraw: 0,

                AMT_MTD_Deposit: 0, // Deposit Amount
                AMT_LMTD_Deposit: 0, // Deposit Amount
                AMT_MTD_Withdraw: 0, // Withdraw Amount
                AMT_LMTD_Withdraw: 0, // Withdraw Amount
                AMT_D_Deposit: 0, // Deposit Amount
                AMT_D_Withdraw: 0, // Withdraw Amount
                AMT_D_Bonus: 0,//Bonus
                AMT_D_AR: 0,//Auto Rebate
                AMT_D_DLS: 0,//Daily Lucky Spin
                AMT_D_Aff: 0,//Affiliate
                AMT_D_TNMT: 0,//Tournament
                AMT_D_MSA: 0,//Prize Drop
                AMT_Y_Bonus: 0,
                AMT_D_PNL: 0, // Day P & L Amount
                AMT_Y_PNL: 0, // Yesterday P & L Amount
                AMT_MTD_PNL: 0, // Month to Date P & L Amount
                AMT_LMTD_PNL: 0, // Last Month to Date P & L Amount
                AMT_LMTD_NPNL: 0, // Last Month to Date Net P & L Amount
                AMT_D_SPR: 0,//Daily SPR W/L
                AMT_MTD_SPR: 0,//Month SPR W/L

                DB_Month: "",
                DB_TDay: "",
                DB_CDay: "",
                DB_DProgress: "",
                DB_DRefresh: "-",

                CurrencySymbol: "",
                View_acce: false,
                top3b: [],
                bottom3b: [],
                menuTitle: "",
                chartOptions: {
                    colors: ['#4CD174', '#312D8D', '#ff1919'],
                    //colors: ['#30878E', '#6D6BA3', '#f0ab4a'],
                    //stroke: {
                    //    width: 2,
                    //},                    
                    chart: {
                        toolbar: {                            
                            tools: {
                                download: this.getDownloadButton(),                                    
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: [{
                                    icon: '<img src="/Content/img/excel.png" width="20" style="padding-left:2px">',
                                    index: 0,
                                    title: 'Download Excel',
                                    class: 'custom-icon',
                                    click: function (chart, options, e) {
                                        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                                        var m = new Date();
                                        var data = months[m.getMonth()];
                                        data += "_x_" + options.config.series[0].data.toString();
                                        data += "_x_" + options.config.series[1].data.toString();
                                        //data += "_x_" + options.config.series[2].data.toString();
                                        window.open(`/api/dc/graphexcel?data=${data}`, '_blank');
                                    }
                                }]
                            },                            
                            export: {
                                csv: {
                                    filename: 'RegisterMemberAndDepositOverview' + this.getCurrentMonth(),
                                    headerCategory: 'Date',
                                },
                                svg: {
                                    filename: 'RegisterMemberAndDepositOverview'
                                },
                                png: {
                                    filename: 'RegisterMemberAndDepositOverview'
                                }
                            }
                        },
                    },
                    xaxis: {
                        categories: [],
                        type: 'category',
                        tickPlacement: 'on',
                        labels: {
                            show: true,
                            hideOverlappingLabels: false
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '10px',
                        },
                        dropShadow: {
                            enabled: true,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: '#000',
                            opacity: 0.45
                        }
                    },
                    savedata: [
                        {
                            name: "Deposit-Money",
                            data: []
                        },
                    ],
                    tooltip: {
                        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                            if (seriesIndex == 0) { // Deposit-Count
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +
                                    '<span>' +
                                    (this.getLanguage["SMB"]["D"]) + ' - ' + (this.getLanguage["WLRPT"]["C"]) +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</br>' +
                                    '<span>' +
                                    (this.getLanguage["SMB"]["D"]) + ' - ' + (this.getLanguage["DB"]["TA"]) +
                                    ': ' +
                                    (Math.round(w.config.savedata[0].data[dataPointIndex] * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: w.config.savedata[0].decimalPoint }) +
                                    '</span>' +
                                    '</div>'
                                );
                            } else if (seriesIndex == 1) {
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +
                                    '<span>' +
                                    (this.getLanguage["DB"]["REG"]) + ' - ' + (this.getLanguage["WLRPT"]["C"]) +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</div>'
                                );
                            } else if (seriesIndex == 2) {
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +
                                    '<span>' +
                                    this.getLanguage["DCSR"]["AM"] + ' - ' + this.getLanguage["WLRPT"]["C"] +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</div>'
                                );
                            }
                        }
                    },

                    plotOptions: {
                        bar: {
                            dataLabels: {
                                orientation: 'vertical',
                                position: 'center' // bottom/center/top
                            }
                        }
                    },
                },
                series: [
                    {
                        //name: this.getLanguage["SMB"]["D"] + ' - ' + this.getLanguage["WLRPT"]["C"],
                        name: "Deposit - Count",
                        type: 'column',
                        data: []
                    },
                    {
                        //name: this.getLanguage['DB']['REG'] + ' - ' + this.getLanguage['WLRPT']['C'],
                        name: "Registered - Count",
                        type: 'column',
                        data: []
                    }
                ],
                chartDDay: true,
                bool_ajaxloading: {
                    dashboardDataList: false
                },
                fromCache:false,
                dataFromCache: false,
                alreadyLoad: false,
                prevCurrencyCode: null
            }
        },
        methods: {            
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.searchAgent = that.dd_agentgroup[0].id;
                                }
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }


            },
            format_date(value) {
                if (value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.searchAgent = null;
                }
                this.searchCurrency = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent && this.searchAgent != 'dummy') {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },

            getdashboardData(isHideCount = false, isHideAmount = false) {
                this.bool_ajaxloading.dashboardDataList = true;
                if (isHideCount) {
                    this.D_Register = '-';
                    this.setMemberOnline = '-';
                    this.setMemberOnline_DESKTOP = '-';
                    this.setMemberOnline_MOBILE = '-';
                    this.setMemberOnline_ANDROID = '-';
                    this.setMemberOnline_IOS = '-';
                    this.setMemberOnline_API = '-';
                    this.D_ActiveMember = '-';
                    this.D_DailyFirstDeposit = '-';
                    this.setTotalMember = '-';
                    this.array_monthlyRS = [];
                    this.array_dailyRS = [];
                    this.MTD_Register = '-';
                    this.L_MTD_Register = '-';
                    this.D_Deposit = '-';
                    this.D_Withdraw = '-';
                    this.Y_Withdraw = '-';
                    this.Y_Deposit = '-';
                    this.MTD_Deposit = '-';
                    this.MTD_Withdraw = '-';
                    this.L_MTD_Deposit = '-';
                    this.L_MTD_Withdraw = '-';
                }

                if (isHideAmount) {
                    this.AMT_LMTD_Withdraw = '-';
                    this.AMT_LMTD_Deposit = '-';
                    this.AMT_MTD_Withdraw = '-';
                    this.AMT_D_Deposit = '-';
                    this.AMT_D_Withdraw = '-';
                    this.AMT_Y_Withdraw = '-';
                    this.AMT_Y_Deposit = '-';
                    this.AMT_D_Bonus = '-';
                    this.AMT_D_AR = '-';
                    this.AMT_D_DLS = '-';
                    this.AMT_D_Aff = '-';
                    this.AMT_D_TNMT = '-';
                    this.AMT_D_MSA = '-';
                    this.AMT_MTD_Deposit = '-';
                    this.AMT_Y_Bonus = '-';
                    this.AMT_MTD_Bonus = '-';
                    this.AMT_MTD_AR = '-';
                    this.AMT_MTD_DLS = '-';
                    this.AMT_MTD_AFF = '-';
                    this.AMT_MTD_TNMT = '-';
                    this.AMT_MTD_MSA = '-';
                    this.AMT_MTD_BonusC = '-';
                    this.AMT_D_PNL = '-';
                    this.AMT_Y_PNL = '-';
                    this.AMT_MTD_PNL = '-';
                    this.AMT_LMTD_PNL = '-';
                    this.AMT_LMTD_NPNL = '-';
                    this.AMT_D_SPR = '-';
                    this.AMT_MTD_SPR = '-';

                }

                var that = this;
                var agi = 0;
                //this.CurrencySymbol = "";

                //If subagent got value, agi = subagent's id, else agent's id
                if (this.searchSubAgent != null) {
                    agi = this.searchSubAgent;
                }
                else {
                    if (this.searchAgent != null)
                        agi = this.searchAgent.split("-")[1];
                }

                var CI = this.searchCurrency;
                var CTCI = this.convertCurrency;

                if (CI != null && CTCI == null) {
                    CTCI = CI;
                }
                let fromCache = that.fromCache == '1' ? 1 : 0;
                let chartDDay = that.chartDDay == '1' ? 1 : 0;
                var CD = moment().format('YYYY-MM-DD HH:mm:ss');
                this.getDataApi(`/api/dc/crc?f[CD]=${CD}&f[AGI]=${agi}&f[CI]=${CI}&f[CTCI]=${CTCI}&f[cache]=${fromCache}&f[byDay]=${chartDDay}`, 
                    function (d, s) {
                        if (s) {
                            that.bool_ajaxloading.dashboardDataList = false;
                            that.dataFromCache = d.fromCache;
                            that.CurrencySymbol = d.CurrencySymbol;
                            that.D_Register = d.totalDailyRegisteredMember;
                            var totalOnline = 0;
                            var totalOnline_DESKTOP = 0;
                            var totalOnline_MOBILE = 0;
                            var totalOnline_ANDROID = 0;
                            var totalOnline_IOS = 0;
                            var totalOnline_API = 0;

                            for (var i = 0; i < d.totalMemberOnline.length; i++) {
                                totalOnline += d.totalMemberOnline[i].TO;
                                if (d.totalMemberOnline[i].IM == 0) { totalOnline_DESKTOP += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 1) { totalOnline_MOBILE += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 2) { totalOnline_ANDROID += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 3) { totalOnline_IOS += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 4) { totalOnline_API += d.totalMemberOnline[i].TO; }
                            }
                            that.top3b = d.Top3B;
                            that.bottom3b = d.Bottom3B;

                            that.setMemberOnline_DESKTOP = totalOnline_DESKTOP;
                            that.setMemberOnline_MOBILE = totalOnline_MOBILE;
                            that.setMemberOnline_ANDROID = totalOnline_ANDROID;
                            that.setMemberOnline_IOS = totalOnline_IOS;
                            that.setMemberOnline_API = totalOnline_API;

                            that.setMemberOnline = totalOnline;

                            that.D_ActiveMember = d.totalActiveMember;
                            that.D_DailyFirstDeposit = d.totalDailyFirstDeposit;
                            that.setTotalMember = d.totalMember;
                            that.array_dailyRS = d.dailyRegisterSource;
                            that.array_monthlyRS = d.MonthlyRegisterSource;
                            that.CD_ActiveMember = d.CD_ActiveMember;
                            //var memtemp = {
                            //    name: "Active Member-Count",
                            //    data: d.CD_Register
                            //}
                            //Vue.set(that.series, 2, memtemp)

                            that.CD_Register = d.CD_Register;
                            that.CYTD_Register = d.CYTD_Register;

                            that.MTD_Register = d.totalMonthlyRegisteredMember;
                            //The name at the bottom of the chart (Registered-Count)
                            //var regtemp = {
                            //    name: that.getLanguage['DB']['RC'],
                            //    data: that.CD_Register
                            //}
                            //Vue.set(that.series, 1, regtemp)

                            that.L_MTD_Register = d.totalLastMonthRegisteredMember;

                            that.SummaryArray = d.getDepositByDay;
                            that.D_Deposit = 0;
                            that.AMT_D_Deposit = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.D_Deposit += that.SummaryArray[i].DC;
                                that.AMT_D_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getWithdrawByDay;
                            that.D_Withdraw = 0;
                            that.AMT_D_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.D_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_D_Withdraw += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getDepositByYesterday;
                            that.Y_Deposit = 0;
                            that.AMT_Y_Deposit = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.Y_Deposit += that.SummaryArray[i].DC;
                                that.AMT_Y_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getWithdrawByYesterday;
                            that.Y_Withdraw = 0;
                            that.AMT_Y_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.Y_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_Y_Withdraw += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberBonusDataByDay;
                            that.AMT_D_Bonus = 0;
                            that.AMT_D_AR = 0;
                            that.AMT_D_DLS = 0;
                            that.AMT_D_Aff = 0;
                            that.AMT_D_TNMT = 0;
                            that.AMT_D_MSA = 0;
                            that.AMT_D_SPR = 0;
                            if (that.SummaryArray) {
                                var arrl = that.SummaryArray.length;
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    if (that.SummaryArray[i].TT == 1) {
                                        that.AMT_D_Bonus += that.SummaryArray[i].TBA;

                                    }
                                    else if (that.SummaryArray[i].TT == 2) {
                                        that.AMT_D_AR += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 3) {
                                        that.AMT_D_DLS += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 4) {
                                        that.AMT_D_Aff += that.SummaryArray[i].TBA;

                                    }
                                    else if (that.SummaryArray[i].TT == 5) {
                                        that.AMT_D_TNMT += that.SummaryArray[i].TBA;

                                    }
                                    else if (that.SummaryArray[i].TT == 6) {
                                        that.AMT_D_MSA += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 7) {
                                        that.AMT_D_SPR += that.SummaryArray[i].TBA;
                                    }
                                }
                            }

                            that.SummaryArray = d.getMemberBonusDataByYesterday;
                            that.AMT_Y_Bonus = 0;
                            if (that.SummaryArray) {
                                var arrl = that.SummaryArray.length;
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    that.AMT_Y_Bonus += that.SummaryArray[i].TBA;
                                }
                            }

                            that.SummaryArray = d.getMemberBonusDataByMonth;
                            that.AMT_MTD_Bonus = 0;
                            that.AMT_MTD_AR = 0;
                            that.AMT_MTD_DLS = 0;
                            that.AMT_MTD_AFF = 0;
                            that.AMT_MTD_TNMT = 0;
                            that.AMT_MTD_MSA = 0;
                            that.AMT_MTD_SPR = 0;
                            if (that.SummaryArray) {
                                var arrl = that.SummaryArray.length;
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    if (that.SummaryArray[i].TT == 1) {
                                        that.AMT_MTD_Bonus += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 2) {
                                        that.AMT_MTD_AR += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 3) {
                                        that.AMT_MTD_DLS += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 4) {
                                        that.AMT_MTD_AFF += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 5) {
                                        that.AMT_MTD_TNMT += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 6) {
                                        that.AMT_MTD_MSA += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 7) {
                                        that.AMT_MTD_SPR += that.SummaryArray[i].TBA;
                                    }
                                }
                            }

                            that.SummaryArray = d.getMemberBonusCappingDataByMonth;
                            that.AMT_MTD_BonusC = 0;
                            var arrl = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrl; i++) {
                                that.AMT_MTD_BonusC += that.SummaryArray[i].TBA;
                            }

                            that.SummaryArray = d.getPNLDataByDay;
                            that.AMT_D_PNL = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_D_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getPNLDataByYesterday;
                            that.AMT_Y_PNL = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_Y_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getPNLDataByMonth;
                            that.AMT_MTD_PNL = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_MTD_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getPNLDataByLastMonth;
                            var arrL = parseInt(that.SummaryArray.length);
                            that.AMT_LMTD_PNL = 0;
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_LMTD_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getNPNLDataByLastMonth;
                            var arrL = parseInt(that.SummaryArray.length);
                            that.AMT_LMTD_NPNL = 0;
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_LMTD_NPNL += that.SummaryArray[i].TBA;
                            }

                            that.getMemberDepositDataByMonthChartS = d.getMemberDepositDataByMonthChartS;

                            that.getMemberDepositDataByYearChartS = d.getMemberDepositDataByYearChartS;

                            //that.SummaryArray = d.getMemberDepositDataByMonthChartS;

                            //that.CD_Deposit = [];
                            //that.CD_DepositMoney = [];
                            //var arrL = parseInt(that.SummaryArray.length);
                            //var i = 0;
                            //for (i = 0; i < arrL; i++) {
                            //    that.CD_Deposit.push(that.SummaryArray[i].DC + '-' + that.SummaryArray[i].TA);

                            //    that.CD_DepositMoney.push(that.SummaryArray[i].TA);
                            //}
                            //The name at the bottom of the chart (Deposit - Count)
                            //var temp = {
                            //    name: that.getLanguage['DB']['DC'],
                            //    data: that.CD_Deposit,
                            //}

                            //var temp1 = {
                            //    name: that.getLanguage['DB']['DM'],
                            //    data: that.CD_DepositMoney,
                            //    decimalPoint: that.CheckIsThousandCurrency(that.CurrencySymbol) ? 3 : 2,
                            //}

                            //Vue.set(that.series, 0, temp)
                            //Vue.set(that.chartOptions.savedata, 0, temp1)
                            that.showChartType(that.chartDDay  ? 1 : 0)

                            that.SummaryArray = d.getMemberDepositDataByMonth;
                            that.MTD_Deposit = 0;
                            that.AMT_MTD_Deposit = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MTD_Deposit += that.SummaryArray[i].DC;
                                that.AMT_MTD_Deposit += that.SummaryArray[i].TA;
                            }


                            that.SummaryArray = d.getMemberWithdrawDataByMonth;
                            that.MTD_Withdraw = 0;
                            that.AMT_MTD_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MTD_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_MTD_Withdraw += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberDepositDataByLastMonth;
                            that.L_MTD_Deposit = 0;
                            that.AMT_LMTD_Deposit = 0;
                            that.CD_Deposit = [];
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.CD_Deposit.push(that.SummaryArray[i].DC);
                                that.L_MTD_Deposit += that.SummaryArray[i].DC;
                                that.AMT_LMTD_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberWithdrawDataByLastMonth;
                            that.L_MTD_Withdraw = 0;
                            that.AMT_LMTD_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.L_MTD_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_LMTD_Withdraw += that.SummaryArray[i].TA;
                            }
                            that.alreadyLoad = true;
                        }
                        that.bool_fullLoading = false;
                    });
            },
            getDateInfo() {
                var that = this;

                this.DB_Month = moment().format('MMMM');
                this.DB_TDay = moment().endOf('month').format('DD');
                this.DB_CDay = moment().format('DD');
                this.DB_DProgress = ((this.DB_CDay * 100) / this.DB_TDay).toFixed(2);
                this.getDataApi(`/api/dc/drdt`,
                    function (d, s) {
                        if (s) {
                            that.DB_DRefresh = moment(d).format("MMM DD, YYYY hh:mm a");
                        }
                    });
            },
            getConvertCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency1 = d.dropdownlist;
                            if (that.dd_currency1.length > 0) {
                                var at = 0;
                                at = that.getUserInfo.AT;
                                if ((that.searchAgent == null && that.bool_firstLogin == false) || (at == 0 && that.bool_firstLogin == false) || (at == 1 && that.bool_firstLogin == false) || (at == 2 && that.bool_firstLogin == false)) {
                                    if (localStorage.getItem('CCUSD') != "") {
                                        for (var i = 0; i < that.dd_currency1.length; i++) {
                                            if (that.dd_currency1[i].id == localStorage.getItem('CCUSD')) {
                                                that.convertCurrency = that.dd_currency1[i].id;
                                                break;
                                            }
                                        }
                                    }
                                    if (that.convertCurrency == null) {
                                        that.convertCurrency = that.dd_currency1[0].id;
                                    }
                                    that.bool_firstLogin = true;
                                }
                            }
                            if (that.searchAgent != null && that.searchCurrency != null && that.bool_firstsearchAgent == false) {
                                that.convertCurrency = null;
                                that.bool_firstsearchAgent = true;
                            }
                            that.AutoUpdate();
                            that.AutoGetUpdate(true, true, true);
                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            changeCurrency(array_C, cC, sC) {
                if (!this.alreadyLoad) {
                    return this.prevCurrencyCode;
                }
                var z = "";
                for (var i = 0; i < array_C.length; i++) {
                    if (cC == array_C[i].id && cC != null) {
                        z = array_C[i].label;
                        break;
                    }
                    else if (sC == array_C[i].id && sC != null) {
                        z = array_C[i].label;
                    }
                }
                this.prevCurrencyCode = z;
                return z;
            },

            MemberOnline() {
                let routeData = this.$router.resolve({ path: '/M/MO', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DepositedMember() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { df: SD, dt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            AllMember() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            Gotop3Brand(istop, agentType, data) {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                if (data && (data.SAGI > 0 || data.AGI > 0)) {
                    if (agentType == 3) {
                        let routeData = this.$router.resolve({ path: '/R/SAGTWL', query: { agit: '3-' + data.AGI, subagi: data.SAGI ,cur: this.convertCurrency, curf: this.searchCurrency, df: SD, dt: ED } });
                        window.open(routeData.href, '_blank');
                    }
                    else {
                        let routeData = this.$router.resolve({ path: '/R/TWLBAG', query: { agit: '3-' + data.AGI, desc: istop, convert: this.convertCurrency, fcur: this.searchCurrency, df: SD, dt: ED } });
                        window.open(routeData.href, '_blank');
                    }
                } else {
                    if (agentType == 3) {
                        let routeData = this.$router.resolve({ path: '/R/SAGTWL', query: { cur: this.convertCurrency, curf: this.searchCurrency, df: SD, dt: ED } });
                        window.open(routeData.href, '_blank');
                    }
                    else {
                        let routeData = this.$router.resolve({ path: '/R/TWLBAG', query: { desc: istop, convert: this.convertCurrency, fcur: this.searchCurrency, df: SD, dt: ED } });
                        window.open(routeData.href, '_blank');
                    }
                }
            },
            MonthlyRegisterSourcePage(rsn, checkHD) {
                var SD = "";
                var ED = "";
                if (checkHD == 'h') {
                    SD = moment().format('DD MMM YYYY 00:00:00');
                    ED = moment().format('DD MMM YYYY 23:59:59');
                }

                let routeData = this.$router.resolve({ path: '/R/RSR', query: { rsn: rsn, df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyRegisterSourcePage(rsn) {
                let routeData = this.$router.resolve({ path: '/MS/RS', query: { agi: this.searchAgent, rsn: rsn } });
                window.open(routeData.href, '_blank');
            },
            PNLPage() {
                var agi = null;
                var CI = this.searchCurrency;
                var CC = this.getCurrencyCode;
                var CTCI = this.convertCurrency;
                var that = this;

                if (CI == null && CTCI == null) {
                    for (var i = 0; i < that.dd_currency1.length; i++) {
                        if (that.dd_currency1[i].label == CC) {
                            CTCI = that.dd_currency1[i].id;
                            break;
                        }
                    }
                }
                else {
                    CTCI = that.convertCurrency;
                }

                if (that.searchAgent != null) {
                    agi = that.searchAgent.split("-")[1];
                }
                let routeData = that.$router.resolve({ path: '/R/TWL', query: { sagi: that.searchAgent, agi: agi, curf: CI, cur: CTCI } });
                window.open(routeData.href, '_blank');
            },
            DailyRPage() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { dRf: SD, dRt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyDPage() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/DR2', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyBPage() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/PR', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyBrandPage() {
                return;
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { dRf: SD, dRt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyAR() {
                let routeData = this.$router.resolve({ path: '/R/LR', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyDLS() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/DLSR', query: { df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyTNMT() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/TNMTR', query: { df: SD, dt: ED, agi: this.searchAgent } });
                window.open(routeData.href, '_blank');
            },
            DailyMSA() {
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/MSAR', query: { df: SD, dt: ED, agi: this.searchAgent } });
                window.open(routeData.href, '_blank');
            },
            DailyBCPage() {
                let routeData = this.$router.resolve({ path: '/P/PSE', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyWPage() {
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/WR2', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyBPage() {
                var agi = null;
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/R/PR', query: { pf: SD, pt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyDLS() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/DLSR', query: { df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyAR() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/LR', query: { df: SD, dt: ED, agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyAFF() {
                let routeData = this.$router.resolve({ path: '/AFF/AFFEL', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MonthlyTNMT() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/TNMTR', query: { df: SD, dt: ED, agi: this.searchAgent } });
                window.open(routeData.href, '_blank');
            },
            MonthlyMSA() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                let routeData = this.$router.resolve({ path: '/R/MSAR', query: { df: SD, dt: ED, agi: this.searchAgent } });
                window.open(routeData.href, '_blank');
            },
            DailyExpenseBreakdown(expensesType) {
                if (!this.checkModuleAccess('EBD', 'R', constAccessType.view))
                    return;
                var SD = moment().format('DD MMM YYYY 00:00:00');
                var ED = moment().format('DD MMM YYYY 23:59:59');
                var sagn = "";
                if (this.searchSubAgent) {
                    const subag = this.dd_subagentgroup.find(f => f.id == this.searchSubAgent);
                    if (subag)
                        sagn = subag.label;
                }
                let routeData = this.$router.resolve({ path: '/R/EBD', query: { df: SD, dt: ED, agi: this.searchAgent, sagi: this.searchSubAgent, sagn: sagn, ci: this.searchCurrency, expensesType: expensesType } });
                window.open(routeData.href, '_blank');
            },
            MonthlyExpenseBreakdown(expensesType) {
                if (!this.checkModuleAccess('EBD', 'R', constAccessType.view))
                    return;
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                var sagn = "";
                if (this.searchSubAgent) {
                    const subag = this.dd_subagentgroup.find(f => f.id == this.searchSubAgent);
                    if (subag)
                        sagn = subag.label;
                }
                let routeData = this.$router.resolve({ path: '/R/EBD', query: { df: SD, dt: ED, agi: this.searchAgent, sagi: this.searchSubAgent, sagn: sagn, ci: this.searchCurrency, expensesType: expensesType  } });
                window.open(routeData.href, '_blank');
            },
            MonthlyRPage() {
                var SD = moment().startOf('month').format('DD MMM YYYY 00:00:00');
                var ED = moment().endOf('month').format('DD MMM YYYY 23:59:59');
                var agi = null;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                let routeData = this.$router.resolve({ path: '/M/ML', query: { dRf: SD, dRt: ED, agi: agi, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MemberActivityPage() {
                let routeData = this.$router.resolve({ path: '/DASH/DMMAL', query: { sa: this.searchAgent, ssa: this.searchSubAgent, sc: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },

            CalculateBCPercentage(AMT_MTD_Bonus, AMT_MTD_BonusC) {
                if (AMT_MTD_Bonus != '-' && !isNaN(AMT_MTD_Bonus) && AMT_MTD_BonusC != '-' && !isNaN(AMT_MTD_BonusC)) {
                    //calculate bonus claimed percentage
                    if (AMT_MTD_BonusC != 0) {
                        var z = (AMT_MTD_Bonus / AMT_MTD_BonusC) * 100;
                    }
                    else if (AMT_MTD_Bonus == 0 && AMT_MTD_BonusC == 0) {
                        z = 0;
                    }
                    else {
                        z = 100;
                    }
                    if (z > 100) {
                        z = 100;
                    }
                    else if (z < -100) {
                        z = -100;
                    }
                    return z;
                } else {
                    return '-';
                }

            },
            countPercentage(daily, yesterday) {
                if (daily != '-' && !isNaN(daily) && yesterday != '-' && !isNaN(yesterday)) {
                    //Calculate count increase or decrease percentage
                    if (yesterday != 0) {
                        var z = ((daily - yesterday) / Math.abs(yesterday)) * 100;
                    }
                    else {
                        z = (daily - yesterday) * 100;
                    }
                    if (z > 100) {
                        z = 100;
                    }
                    else if (z < -100) {
                        z = -100;
                    }
                    return z;
                } else {
                    return '-';
                }
            },
            Compare_YD(today, yesterday) {
                var result = 0;
                result = today - yesterday;
                return result;

            },
            countMoneyPercentage(daily, yesterday) {
                //Calculate Money increase or decrease percentage
                if (yesterday != 0) {
                    var z = ((daily - yesterday) / Math.abs(yesterday)) * 100;
                }
                else {
                    z = (daily - yesterday);
                }
                //if (z > 100) {
                //    z = 100;
                //}
                //else if (z < -100) {
                //    z = -100;
                //}
                return z;
            },
            countTotalNPNL(TotalWL, TotalBC) {
                var netProfit = parseFloat(TotalWL) - parseFloat(TotalBC);
                return netProfit;
            },
            AutoUpdate() {
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            AutoGetUpdate(isHideCount = false, isHideAmount = false, isLoading = false) {
                this.nextGetUpdate(isHideCount, isHideAmount, isLoading);
                var that = this;
                this.AutoGetUpdateTO = setTimeout(function () {
                    that.AutoGetUpdate();
                }, 60000);
            },
            nextGetUpdate: function (isHideCount = false, isHideAmount = false, isLoading = false) {
                var CTCI = this.convertCurrency;
                var CC = this.getCurrencyCode;
                if (this.convertCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                    for (var i = 0; i < this.dd_currency1.length; i++) {
                        if (this.dd_currency1[i].label == CC) {
                            CTCI = this.dd_currency1[i].id;
                            break;
                        }
                    }
                    localStorage.setItem('CCUSD', CTCI);
                }
                else {
                    localStorage.setItem('CCUSD', this.convertCurrency);
                }


                if (isLoading) {
                    this.bool_fullLoading = true;
                }
                this.getDateInfo();
                if (!this.bool_ajaxloading.dashboardDataList) {
                    this.getdashboardData(isHideCount, isHideAmount);
                }
                //this.nextUpdate(isLoading);
            },
            getLang() {
                this.chartOptions.chart.toolbar.tools.customIcons[0].title = this.getLanguage['DB']['DE'];                
                this.menuTitle = this.getLanguage['DB']['MENU'];                
            },
            getDownloadButton() {
                return `<div title="${this.menuTitle}"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg></div>`;
            },
            showChartType(value, autoLoad = false) {

                this.chartDDay = value === 1;

                if(autoLoad)(
                    this.nextGetUpdate(true, true, true)
                )
                else{
                    const today = new Date();

                    // Generate date range based on the selected value
                    const dateRange = value === 1
                        ? [...Array(31)].map((_, i) => {
                            let date = new Date();
                            date.setDate(today.getDate() - (30 - i));
                            return date.getDate().toString(); // Use 'DD MMM' if needed
                        })
                        : [...Array(12)].map((_, i) => {
                            let date = new Date(today.getFullYear(), today.getMonth() - (11 - i), 1);
                            return date.toLocaleString('en-US', { month: 'short', year: 'numeric' });
                        });

                    // Update chart options
                    this.chartOptions = {
                        ...this.chartOptions,
                        xaxis: { categories: dateRange }
                    };

                    this.SummaryArray = this.chartDDay ? this.getMemberDepositDataByMonthChartS : this.getMemberDepositDataByYearChartS;

                    // Process deposit data
                    this.CD_Deposit = this.SummaryArray.map(item => `${item.DC}-${item.TA}`);
                    this.CD_DepositMoney = this.SummaryArray.map(item => item.TA);

                    // Prepare series data
                    const decimalPoint = this.CheckIsThousandCurrency(this.CurrencySymbol) ? 3 : 2;

                    Vue.set(this.series, 0, { name: this.getLanguage['DB']['DC'], data: this.CD_Deposit });
                    Vue.set(this.chartOptions.savedata, 0, { name: this.getLanguage['DB']['DM'], data: this.CD_DepositMoney, decimalPoint });

                    Vue.set(this.series, 1, {
                        name: this.getLanguage['DB']['RC'],
                        data: this.chartDDay ? this.CD_Register : this.CYTD_Register
                    });
                }
            }
        },

        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            clearTimeout(this.AutoGetUpdateTO);
            next();
        },
        created() {
            this.fromCache = this.$route.query.c;
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.DBM';
            this.View_acce = this.checkModuleAccess('DBM', 'DASH', constAccessType.view);
            this.View_acce2 = this.checkModuleAccess('DMMAL', 'DASH', constAccessType.view);
            this.getLang();
            this.menuTitle = this.getLanguage['DB']['MENU'];
        },
        mounted() {
            this.getDateInfo();
            this.getAgentGroup();
            this.getCurrencyList();
            this.getConvertCurrencyList();
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }            
        },
        watch: {
            getLanguage() {
                //this.getUserActivityList();
                this.getLang();                
                this.getCurrencyList();
                this.nextGetUpdate(true, true, true);
            },
            convertCurrency(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.alreadyLoad = false;
                }
            },
            searchCurrency(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.alreadyLoad = false;
                }
            },
            menuTitle(newTitle) {
                this.chartOptions.chart.toolbar.tools.download = this.getDownloadButton();
            }
        }
    }

</script>

<style scoped>
    h6.title-db, h5.title-db {
        height: 30px;
    }

    .plus-button {
        border: 2px solid #a3a3a3;
        background-color: #a3a3a3;
        font-size: 16px;
        height: 2em;
        width: 2em;
        border-radius: 999px;
        position: relative;
        float: right;
    }

        .plus-button:after, .plus-button:before {
            content: "";
            display: block;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .plus-button:before {
            height: 1em;
            width: 0.2em;
        }

        .plus-button:after {
            height: 0.2em;
            width: 1em;
        }

    .plus-button--small {
        font-size: 12px;
    }

    .theme-cicle-title {
        display: flex;
        align-items: center;
    }

    .text-grey {
        color: #808080;
    }

    /*.text-top3 {
        color: #2C772C;
    }

    .text-bottom3 {
        color: rgb(229, 54, 54) !important;
    }*/

    .apexcharts-text tspan {
        font-weight: 700;
    }

    .durationActive {
        padding: 2px 10px;
        border-radius: 5px;
        color: #fff;
        font-weight: bold;
        font-size: 12px;
        background-color: rgb(111, 107, 214);
        border: 1px solid rgba(0, 0, 0, .125);
        box-shadow: 0 7px 43px rgba(0, 0, 0, .1);
    }

    .durationNoActive {
        background: #fff;
        padding: 2px 10px;
        border-radius: 5px;
        color: rgb(128, 132, 136);
        font-size: 12px;
        border: 1px solid rgba(0, 0, 0, .125);
    }
</style>



// WEBPACK FOOTER //
// src/components/DashboardMonitoring.vue